import { Component } from '@angular/core';
import { DialogCloseButtonComponent } from '@innersource/common-ui-components';

/** Displays the English and German terms of service. */
@Component({
  selector: 'app-tos-dial',
  templateUrl: './tos-dial.component.html',
  styleUrl: './tos-dial.component.scss',
  imports: [DialogCloseButtonComponent],
})
export class TosDialComponent {}
